import {IApplicationPayload} from "@/features/applications/types/IApplicationPayload";

import {getInvestmentLeadMutationKey, getLeadMutationKey} from "./get_lead_mutation_key";

/** Picks the cache key matching whichever target the payload carries. */
export const getLeadMutationCacheKey = (payload: IApplicationPayload) =>
    payload.offer === undefined ? getLeadMutationKey(payload.property) : getInvestmentLeadMutationKey(payload.offer);
import {IApplicationPayload} from "@/features/applications/types/IApplicationPayload";

import {getInvestmentLeadMutationKey, getLeadMutationKey} from "./get_lead_mutation_key";

/** Picks the cache key matching whichever target the payload carries. */
export const getLeadMutationCacheKey = (payload: IApplicationPayload) =>
    payload.offer === undefined ? getLeadMutationKey(payload.property) : getInvestmentLeadMutationKey(payload.offer);
